import React, { memo } from 'react';
import Head from 'next/head';

import QuizListContainer from 'containers/QuizListContainer';
import {
  quizListUrl,
  genresUrl,
  quizListRaitingUrl,
} from 'utils/api/requestUrls';
import { translit } from 'utils';
import { genresMetaTags } from 'customTexts/GenresMetaTags';
import { mainPageTexts } from 'customTexts/MainPageTexts';

const Home = (props: any) => {
  const {
    tags
  } = props;

  return (
    <>
      <Head>
        <title>{tags?.title}</title>
        <meta name="description" content={tags?.description} />
      </Head>

      <QuizListContainer {...props} />
    </>
  );
};

export const getServerSideProps = async (context) => {
  const { req, res } = context;
  const tags = genresMetaTags?.[context.query.filterid];
  const genresText = mainPageTexts?.[context.query.filterid] || null;

  let activeCategoryId = null;

  const genresResponse = await fetch(genresUrl);
  const genresFirstData = await genresResponse.json();

  if (!!genresFirstData?.length) {
    genresFirstData.map(item => {
      if (translit(item.genre) === context.query.filterid) {
        activeCategoryId = item.id
      };
    });
  };

  const questListResponse = await fetch(quizListUrl(activeCategoryId, null));
  const questListFirstData = await questListResponse.json();

  const raitingResponse = await fetch(quizListRaitingUrl);
  const raitingFirstData = await raitingResponse.json();

  if (req.headers.host.match(/^www/) !== null) {
    res.writeHead(301, {
      location: "https://" + req.headers.host.replace(/^www./, "") + req.url,
    });
    res.end();
  };

  return {
    props: {
      tags,
      genresText,
      questListFirstData: questListFirstData?.content,
      genresFirstData,
      raitingFirstData,
      activeCategoryId
    }
  };
};

export default memo(Home);
